import React, { useEffect, useState } from "react";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { db } from "../../FireBase/firestore";
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";

const OrderHistory = () => {
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 834;
    const isMobile = window.innerWidth <= 440;
    const loggedUser = JSON.parse(localStorage.getItem("loggedInUser"));
    const userEmail = loggedUser?.email;
    const { orderId } = useParams();
    const [orders, setOrders] = useState([]);
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const q = query(
                    collection(db, "orders"),
                    where("contact", "==", userEmail)
                );
                const querySnapshot = await getDocs(q);
                const ordersList = [];
                querySnapshot.forEach((doc) => {
                    ordersList.push({
                        id: doc.id,
                        ...doc.data()
                    });
                });
                ordersList.sort((a, b) => Number(a.orderId) - Number(b.orderId));
                setOrders(ordersList);
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };
        if(userEmail){
            fetchOrders();
        }
    }, [userEmail]);
    const getStatusConfig = (status) => {
        switch (status) {
            case "Pending":
                return { severity: "warning", icon: "pi pi-clock" };
            case "Confirmed":
                return { severity: "success", icon: "pi pi-check-circle" };
            case "Cancelled":
                return { severity: "danger", icon: "pi pi-times-circle" };
            default:
                return { severity: "info", icon: "pi pi-info-circle" };
        }
    };
    const statusConfig = getStatusConfig(orders?.status);
    const formatPKR = (value) => {
        if (value === null || value === undefined) return "-";
        return Number(value).toLocaleString("en-PK");
    };

    return (
        <>
            <div className="container mt-5">
                <NavBar />
                <div className="custome-padding-top" style={{ paddingTop: isMobile ? "9rem" : isTablet ? "10rem" : "12rem" }}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h1 className='fw-bold text-black'>Order History</h1>
                    </div>
                    {orders.length > 0 ? (
                        <>
                            {orders.map((order, index) => {
                                const cart = order?.cartItems || {};
                                const items = cart.items || [];
                                return (
                                    <div key={index} className="mb-5">
                                        <div style={{ background: '#f9f9f9', padding: '24px', borderRadius: '10px' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                <h3 className='fw-bold text-black'>Order #{order?.orderId}</h3>
                                                <Tag value={order?.status} severity={statusConfig.severity} icon={statusConfig.icon}/>
                                            </div>
                                            {items.map((item, idx) => (
                                                <div key={idx} style={{ display:'flex', justifyContent:'space-between', marginBottom:'20px' }}>
                                                    <div style={{ display:'flex' }}>
                                                        <img src={item?.productImage} alt={item?.productName} style={{ width:'60px', height:'60px', marginRight:'10px' }} loading="lazy"/>
                                                        <div>
                                                            <div style={{ fontWeight:'bold' }}>{item?.productName}</div>
                                                            <div style={{ fontSize:'13px', color:'#777' }}>
                                                                {item?.productColor} / {item?.productSize}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{fontWeight:500 }}>
                                                        Qty: {item?.productQuantity}
                                                    </div>
                                                </div>
                                            ))}
                                            <Divider />
                                            <div style={{ display:'flex', justifyContent:'space-between', fontWeight:'bold' }}>
                                                <span>Order Total</span>
                                                <span>Rs. {formatPKR(cart?.total)}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </>
                    ) : (
                        <div className="text-center mt-5">
                            <h4>No Order History Found</h4>
                        </div>
                    )}
                </div>
            </div>
            <Footer/>
        </>

    );
};
export default OrderHistory;